import {
  useOrderFormStore,
  useOrderFormStoreActions,
} from '@/modules/order/stores/order-form.store'

import type { TProducts } from '../types/product.type'
import { useCrudProductInOrderHook } from './use-crud-product-in-order.hook'

type TAddValuesInProduct = Pick<
  TProducts,
  | 'quantidade'
  | 'porcDescontoTabela'
  | 'valorUnitario'
  | 'valorUnitarioBase'
  | 'flagPrecoFixo'
>

export const useControllerProductHook = (product: TProducts) => {
  const {
    jsonOrderForm,
    actions: { setUpdatedProductDetails },
  } = useOrderFormStore()
  const { setJsonOrderForm } = useOrderFormStoreActions()

  const { addProduct, updateProduct } = useCrudProductInOrderHook()

  const addValuesInProduct = ({
    flagPrecoFixo,
    porcDescontoTabela,
    quantidade,
    valorUnitario,
  }: TAddValuesInProduct) => {
    product.quantidade = quantidade
    product.porcDescontoTabela = porcDescontoTabela
    product.valorUnitario = valorUnitario
    product.valorUnitarioBase = flagPrecoFixo ? valorUnitario : product.valorUnitarioBase

    product.flagPrecoFixo = quantidade === 0 ? false : flagPrecoFixo
  }

  const checkIfThatProductOnOrder = () => {
    return jsonOrderForm?.itemsCalculo?.findIndex(
      (item) => item.fkProduto === product?.fkProduto,
    )
  }

  const addOrUpdateProductOnOrder = (data: TAddValuesInProduct) => {



    addValuesInProduct({
			...data,
			flagPrecoFixo: jsonOrderForm.operacao.controlaLucratividade ? true : data.flagPrecoFixo
		})

    const hasProduct = checkIfThatProductOnOrder()

    if (hasProduct === -1) {
      setUpdatedProductDetails(true)
      return addProduct(product)
    }

    if (data.quantidade === 0) {
      const newItens = jsonOrderForm.itemsCalculo.filter(
        (item) => item.fkProduto !== product.fkProduto,
      )

      setUpdatedProductDetails(true)


      setJsonOrderForm({
        ...jsonOrderForm,
        itemsCalculo: newItens,
      })
    }

    setUpdatedProductDetails(true)

    updateProduct({
      ...product,
    })
  }

  return {
    addOrUpdateProductOnOrder,
  }
}
